define('v3/Common/Components/SelectionBar/SelectionBar.Component',[
	'knockout',
	'jquery',
	'lodash',
	'text!v3/Common/Components/SelectionBar/SelectionBar.Component.html',
	'v3/Common/Bindings/SelectionBar.Binding',
	'v3/Common/Bindings/SvgIcon.Binding'
], function (ko, $, _, htmlString) {
	function validateParams (params) {
		if (!params.template) {
			throw new Error('params.template is expected.');
		}
		if (!params.data) {
			throw new Error('params.data is expected.');
		}
	}

	function SelectionBarViewModel (params) {
		var self = this;
		validateParams(params);

		self.icon = params.icon || false;
		self.title = params.title || '';
		self.className = params.class || '';

		self.hasClose = !_.isNil(params.hasClose) ? params.hasClose : true;
		self.onClose = params.onClose;

		self.template = params.template;
		self.data = params.data;

		self.visibleInit = true;
		self.isVisible = params.visible || ko.observable(true);

		self.hideSelectionBar = function () {
			if (self.onClose) {
				self.onClose();
			}

			self.isVisible(false);
		};

		self.toggleSelectionBar = ko.computed(function () {
			var className;
			if (self.isVisible()) {
				className = 'slideIn';
				self.visibleInit = false;
			} else if (!self.isVisible() && !self.visibleInit) {
				className = 'goAway';
				self.visibleInit = true;
			} else {
				className = '';
			}

			return className;
		});

		self.toggleSelectionBar.subscribe(function () {
			if (self.visibleInit) {
				$('.selection-bar').one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function () {
					$(this).removeClass('goAway');
				});
			}
		});
	}

	return { viewModel: SelectionBarViewModel, template: htmlString };
});
